import React from 'react';
import { useParams } from 'react-router-dom';
import { ProFormTextArea } from '@ant-design/pro-form';
import PropTypes from 'prop-types';
import ProForm from '../../../layout/ProForm';
import { FormUpload } from '../../../input';
import { WIDTH_2_COL } from '../../../../constants/form';

const WithdrawalForm = ({ onFinish, initialValues, projectFrozen }) => {
  const { projectId } = useParams();

  return (
    <ProForm
      initialValues={initialValues}
      previousLevel={`/projects/${projectId}/withdrawals`}
      onFinish={onFinish}
      disabled={projectFrozen}
    >
      <FormUpload
        maxCount={1}
        name="progressReport"
        label="Progress Report"
        rules={[{ required: true, message: 'Please upload file!' }]}
        projectId={projectId}
        subFolder="WITHDRAWAL"
        disabled={projectFrozen}
      />
      <ProFormTextArea
        width={WIDTH_2_COL}
        name="justification"
        label="Justification"
        placeholder="justification"
        disabled={projectFrozen}
        rules={[{ required: true, message: 'Please enter justification!' }]}
      />
    </ProForm>
  );
};

WithdrawalForm.defaultProps = {
  initialValues: {},
  projectFrozen: false,
};

WithdrawalForm.propTypes = {
  onFinish: PropTypes.func.isRequired,
  initialValues: PropTypes.object.isRequired,
  projectFrozen: PropTypes.bool.isRequired,
};

export default WithdrawalForm;
